import { useEffect, useState } from 'react';
import { debounce } from 'throttle-debounce';
import { slateMock3SkyeStyle } from '../layouts/AdminPage/SchemesAndFunds/DynamicDetails';
import { getStyle } from '../Utils/styleConversion';
import { simpleInlineStyles } from '@threeskye/editor-component-slate';
import Editor from './Editor';
import './SlateStaticData.scss';
import './SimpleEditor.scss';


const SimpleEditor = (props) => {
    const [content, setContent] = useState(null);
    const [originalContent, setOriginalContent] = useState(null);
    const [editorKey, setEditorKey] = useState(1);
    //const [toolbar, setToolbar] = useState({ type: "full" });
    const [toolbar, setToolbar] = useState({ type: "simple", allowLinks: true });
    const [flattenedStyles, setFlattenedStyles] = useState(null);
    const [editable, setEditable] = useState(props.readOnly ? false : true);
    const colour1 = "#164a9a"
    const colourOptions = [colour1, '#2536f0']
    const addins = simpleInlineStyles()

    const config = {
        styles: {
            "p": "body-text",
            "li": "body-text",
            "h1": "section-header-blue",
            "h2": "section-header-blue-medium",
            "h3": "section-header-blue-small",
            "tableHeader": "section-header-blue-small",
            "tableFooter": "body-text",
            "imageHeader": "section-header-blue-small",
            "imageFooter": "body-text",
            "cell": "sidebar-table-cell",
            "cellHeader": "sidebar-table-cell-header",
            "a": "hyper-link"
        }
    }

    useEffect(() => {
        listener(props.load);
        if (props.changesCancelled) {
            listener(props.load);
            props.setChangesCancelled(false);
        }
    }, [props.changesCancelled]);

    // useEffect(() => {
    //     if (!props.readOnly) {
    //         hideButtons();
    //     }
    // }, [props.readOnly]);

    const onChange = debounce(300, debounceOnChange);

    function listener(genericContent) {
        setEditable(false);
        if (genericContent && genericContent !== null && genericContent !== "") {
            if (genericContent.startsWith("[") && genericContent.endsWith("]")) {
                const parsed = JSON.parse(genericContent);
                setContent(parsed);
                setOriginalContent(parsed);
                setEditorKey(editorKey + 1);
            } else {
                setContent([{ type: 'text', children: [{ text: genericContent }] }]);
                setOriginalContent([{ type: 'text', children: [{ text: genericContent }] }]);
            }
        } else {
            setContent([{ type: 'text', children: [{ text: "" }] }]);
            setOriginalContent([{ type: 'text', children: [{ text: "" }] }]);
            setEditorKey(editorKey + 1);
        }

        const myStyles = Object.keys(config.styles).map(key => {
            const actual = slateMock3SkyeStyle[config.styles[key]];
            if (!actual) return null
            const converted = getStyle(actual) || {};
            converted.lineHeight = props.lineHeight || 1.2;
            const val = {};
            val[key] = converted;
            return val;
        });

        const finalFlattenedStyles = {};
        myStyles.forEach(style => Object.assign(finalFlattenedStyles, style));
        setFlattenedStyles(finalFlattenedStyles);
        setEditable(true);
    }

    function debounceOnChange(data) {
        props.onChange(data, props.index);
        setContent(data);
        return;
    }

    // getStyle comes from Utils/styleConversion.js (option 1B) — one shared
    // template-style → CSS conversion for every consumer.

    // function hideButtons() {
    //     const toolbarElements = document.getElementsByClassName("hover-toolbar");
    //     Array.from(toolbarElements).forEach(toolbarElement => {
    //         toolbarElement.classList.add("short-toolbar");
    //     })
    // }


    return (
        <div className={`slate-disclaimer-data${props.readOnly ? " read-only" : ""}${props.passedClassName ? " " + props.passedClassName : ""}`}>
            <Editor
                key={editorKey}
                readOnly={props.readOnly ? props.readOnly : !editable}
                options={{}}
                load={content}
                styles={slateMock3SkyeStyle}
                myStyles={flattenedStyles || {}}
                onChange={onChange}
                addins={addins}
                toolbar={toolbar}
                setToolbar={props.readOnly ? () => null : setToolbar}
                colourOptions={colourOptions}
                throwToaster={null}
                simpleToolBar={true}
            />
        </div>
    )
}

export default SimpleEditor;